import React from "react";
import { AbsoluteFill, interpolate } from "remotion";
import { useEnvelope, BellIcon, PlayIcon, YT_RED, BTN_SHADOW, TEXT_SHADOW } from "./CTAKit";

// CTA #1 — SUBSCRIBE + ringing bell. Red pill, bottom-center.
export const CTASubscribeBell: React.FC<{ channel?: string; bottom?: number }> = ({
  channel = "FACTORY PROCESS DECODER",
  bottom = 90,
}) => {
  const { o, s, y, frame, fps } = useEnvelope();
  // bell rings (shakes) after it lands
  const t = frame - Math.round(fps * 0.6);
  const ring = t > 0 ? Math.sin(t * 0.9) * interpolate(t, [0, fps * 1.6], [16, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }) : 0;
  const pulse = 1 + 0.04 * Math.sin(frame * 0.25);

  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "center", paddingBottom: bottom }}>
      <div style={{ opacity: o, transform: `translateY(${y}px) scale(${s})`, display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <div style={{ color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 800, fontSize: 22, letterSpacing: 1, textShadow: TEXT_SHADOW }}>
          ENJOYING THIS? <span style={{ color: "#FFC400" }}>SUBSCRIBE</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div
            style={{
              display: "flex", alignItems: "center", gap: 10,
              background: YT_RED, color: "#fff", fontFamily: "Inter, Arial, sans-serif",
              fontWeight: 900, fontSize: 26, letterSpacing: 1.5,
              padding: "14px 26px", borderRadius: 999, boxShadow: BTN_SHADOW,
              transform: `scale(${pulse})`,
            }}
          >
            <PlayIcon size={26} /> SUBSCRIBE
          </div>
          <div style={{ width: 56, height: 56, borderRadius: 999, background: "rgba(20,20,24,0.92)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: BTN_SHADOW }}>
            <BellIcon size={28} ring={ring} />
          </div>
        </div>
        <div style={{ color: "rgba(255,255,255,0.85)", fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 14, letterSpacing: 3, textShadow: TEXT_SHADOW }}>
          {channel}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
